<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc_marker-1">Contents</h2>
<p class="veryfirst"><a href="#/Text/intro#toc_marker-2">Introduction: <i>Defleshing the Human Experience</i></a></p>
<blockquote>
<p class="left"><a href="#/Text/ch1#toc_marker-3">1 Rootless, Disengaged and Screen Addicted</a></p>
<p class="firstleft"><a href="#/Text/ch2#toc_marker-4">2 The Schizophrenic Sense of Self</a></p>
<p class="firstleft"><span href="#/Text/ch3#toc_marker-5" title="Link target outside of Sample">3 Wandering Aimlessly in a Moral Minefield</span></p>
<p class="firstleft"><span href="#/Text/ch4#toc_marker-6" title="Link target outside of Sample">4 The Moral Ambiguity of Our Time</span></p>
<p class="firstleft"><span href="#/Text/ch5#toc_marker-7" title="Link target outside of Sample">5 Religion as an Embodied Experience</span></p>
<p class="firstleft"><span href="#/Text/ch6#toc_marker-8" title="Link target outside of Sample">6 Learning Embodiment from the Master</span></p>
<p class="firstleft"><span href="#/Text/ch7#toc_marker-9" title="Link target outside of Sample">7 Desire, Idolatry and Discipleship</span></p>
<p class="firstleft"><span href="#/Text/ch8#toc_marker-10" title="Link target outside of Sample">8 We Are Spirited Bodies</span></p>
<p class="firstleft"><span href="#/Text/ch9#toc_marker-11" title="Link target outside of Sample">9 Mission in the Excarnate Age</span></p>
<p class="firstleft"><span href="#/Text/ch10#toc_marker-12" title="Link target outside of Sample">10 Defying Church-World Dualism</span></p>
<p class="firstleft"><span href="#/Text/ch11#toc_marker-13" title="Link target outside of Sample">11 Placed Persons</span></p>
<p class="firstleft"><span href="#/Text/ch12#toc_marker-14" title="Link target outside of Sample">12 Adopting an Incarnational Posture</span></p>
<p class="firstleft"><span href="#/Text/ch13#toc_marker-15" title="Link target outside of Sample">13 The First Page of the End of Despair</span></p>
<p class="firstleft"><span href="#/Text/ch14#toc_marker-16" title="Link target outside of Sample">14 Getting There</span></p>
</blockquote>
<p class="left"><span href="#/Text/epilogue#toc_marker-17" title="Link target outside of Sample">Epilogue: <i>Christ in Us and We in Christ</i></span></p>
<p class="firstleft"><span href="#/Text/notes#toc_marker-18" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/aboutauthor#toc_marker-19" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/forge#toc_marker-20" title="Link target outside of Sample">Forge Missions Training Network</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#toc_marker-21" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4633dfed